module.exports = __webpack_public_path__ + "static/media/learningreact.da253db3.pdf";